import { CompareModule } from '../compare/compare.module';
import { OfferEffects } from './store/effects/index';
import { EffectsModule } from '@ngrx/effects';
import {
  VIEW_OFFERS_FEATURE,
  viewOffersReducers,
} from './store/reducers/index';
import { StoreModule } from '@ngrx/store';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';

import * as fromComponents from './components';
import * as fromContainers from './containers';
import { DgxQmModule } from '@domgen/dgx-fe-qm';
import { DgxComponentsButtonModule } from '@domgen/dgx-fe-components/button';

@NgModule({
  declarations: [...fromComponents.components, ...fromContainers.containers],
  imports: [
    CommonModule,
    SharedModule,
    CompareModule,
    StoreModule.forFeature(VIEW_OFFERS_FEATURE, viewOffersReducers),
    EffectsModule.forFeature(OfferEffects),
    DgxQmModule.forRoot(),
    DgxComponentsButtonModule
  ],
  exports: [...fromComponents.components, ...fromContainers.containers],
})
export class ViewOffersModule {}
